<template>
    <span>
        <v-tooltip v-if="result.mobilized" :color="bgPassed" top>
            <template #activator="{ on }">
                <v-icon v-if="result.mobilized" :color="bgPassed" v-on="on">check_circle</v-icon>
            </template>

            Score: {{ result.prelims_score }}<br />
            <template v-for="({ levelFrom, levelTo, score }, index) in mobilityScores">
                <span :key="index"> Mobility Score (from {{ levelFrom }} to {{ levelTo }}): {{ score }}<br /> </span>
            </template>
        </v-tooltip>
        <v-tooltip v-else-if="result.mobilized === false && mobility" :color="bgFailed" top>
            <template #activator="{ on }">
                <v-icon :color="bgFailed" v-on="on"> cancel </v-icon>
            </template>
            <div :class="`${fgFailed}--text`">
                Score: {{ result.prelims_score }}<br />

                <template v-for="({ levelFrom, levelTo, score }, index) in mobilityScores">
                    <span :key="index">
                        Mobility Score (from {{ levelFrom }} to {{ levelTo }}): {{ score }}<br />
                    </span>
                </template>
            </div>
        </v-tooltip>
        <v-tooltip v-else-if="result.mobilized === null" top>
            <template #activator="{ on }">
                <v-icon color="grey" v-on="on">mdi-minus-circle-outline</v-icon>
            </template>

            <!-- Provide a reason that they did not mobilize -->
            <span v-if="['1', '2', '3', '4'].includes(result.level)"> Level 1-4 does not require mobilization. </span>

            <span v-else-if="result.is_elite && !meet.elite_mobility">
                {{ meet.title }} is not an elite mobility meet.
            </span>
        </v-tooltip>
    </span>
</template>

<script>
import Meet from '@/Models/Meet.js';

export default {
    name: 'MobilityCheck',

    props: {
        result: {
            type: Object,
            required: true,
        },

        mobility: {
            type: [Object, Array, null],
            required: false,
            default: null,
        },

        meet: {
            type: Meet,
            required: true,
        },

        bgPassed: {
            type: String,
            required: false,
            default: 'green',
        },

        bgFailed: {
            type: String,
            required: false,
            default: 'red',
        },

        fgPassed: {
            type: String,
            required: false,
            default: 'white',
        },

        fgFailed: {
            type: String,
            required: false,
            default: 'white',
        },
    },

    computed: {
        mobilityScores() {
            if (!this.mobility || this.mobility.length === 0) {
                return [];
            }

            const formatter = mobility => {
                const format = { levelFrom: mobility.level_from, levelTo: mobility.level_to };

                if (mobility?.total_w_tof && this.result.has_tof) {
                    return { ...format, score: mobility.total_w_tof };
                }

                return { ...format, score: mobility.total_score };
            };

            if (Array.isArray(this.mobility)) {
                return this.mobility.map(formatter);
            }

            return formatter(this.mobility);
        },
    },
};
</script>
